import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import "../styles/Services.css";

const services = [
  {
    title: "Cricket Betting",
    image: "cricketservices.webp",
  },
  {
    title: "Football Betting",
    image: "footballservices.webp",
  },
  {
    title: "Horse Race Betting",
    image: "horseraceservices.webp",
  },
  {
    title: "Indian Card Games",
    image: "indiancardservices.webp",
  },
  {
    title: "Tennis Betting",
    image: "tennisservices.webp",
  },
  {
    title: "Casino",
    image: "casinoservices.webp",
  },
];

const Services = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918977772819?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918977772819?text=${encodedMessage}`;

  // Function to create URL-friendly slugs
  const slugify = (text) =>
    text
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "");

  return (
    <div className="services-page">
      {/* ✅ Meta Tags */}
      <Helmet>
        <title>Reddy Anna - Betting Services India for Cricket & Casino</title>
        <meta
          name="description"
          content="Explore Reddy Anna betting services in India including cricket betting, casino games and secure online IDs."
        />

        {/* ✅ AboutPage Schema */}
        <script type="application/ld+json">
          {`
            {
 "@context": "https://schema.org",
 "@type": "Service",
 "name": "Reddy Anna - Betting Services India for Cricket & Casino",
 "url": "https://reddyannaaid.com/services",
 "description": "Explore Reddy Anna betting services in India including cricket betting, casino games and secure online IDs.",
 "provider": {
   "@type": "Organization",
   "name": "Reddy Anna"
 },
 "areaServed": "India"
}

          `}
        </script>
      </Helmet>
      <header className="hero-section">
        <h1 className="hero-title">
          Explore Our <span className="highlight">Services</span>
        </h1>
        <p className="hero-description">
          Welcome to Reddy Anna Book Official, your premier destination for a
          secure, innovative, and exhilarating online gaming experience. We take
          pride in offering a vast selection of sports games, including cricket,
          basketball, football, and tennis, catering to every sports
          enthusiast’s passion. Our live casinos deliver an engaging and
          real-time gaming atmosphere, where every moment is filled with
          excitement and opportunity. Your security is our priority—our platform
          is fortified with advanced encryption to protect your information at
          every step. With a seamless, user-friendly interface and a steadfast
          commitment to responsible gaming,
          <span> Reddy Anna</span> promises an unparalleled gaming journey
          that’s as safe as it is thrilling. Join us today and step into a world
          where entertainment meets innovation, and every game brings the
          potential for greatness.
        </p>
      </header>

      <section className="services-section">
        <h2 className="section-title">
          All <span className="highlight">Reddy Anna</span> Services
        </h2>
        <div className="service-cards">
          {services.map((service, index) => (
            <Link
              to={`/${slugify(service.title)}`}
              className="service-card"
              key={index}
            >
              <img
                src={service.image}
                alt={service.title}
                className="service-image"
              />
              <h3 className="service-title">{service.title}</h3>
            </Link>
          ))}
        </div>

        <div className="service-btn">
          <a
            href={ContactLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            Contact Us @ 7777857777
          </a>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            WhatsApp Us @ 7777077773
          </a>
        </div>
      </section>
    </div>
  );
};

export default Services;
